import React, {useState} from 'react'
import Offer from './Offer';
import Technologies from './Technologies';
import Experience from './Experience';

const About = () => {

    const [content, setContent] = useState('');

    const handleClick = (section) => setContent(section);

    const Section = () =>
      content === "" || content === "1" ? (
        <Offer />
      ) : ( content === "2" ) ? (
        <Technologies />
      ) : ( content === "3" ) ? (
        <Experience />
        ) : ''

      const ButtonCapability = () => (
        <button className={`more ${content === "" || content === "1" ? "used" : ''}`} onClick={() => handleClick("1")} type="button">
          Moja oferta
        </button>
      );

      const ButtonTechnologies = () => (
        <button className={`more ${content === "2" ? "used" : ''}`} onClick={() => handleClick("2")} type="button">
          Technologie
        </button>
      );

      const ButtonExperience = () => (
        <button className={`more ${content === "3" ? "used" : ''}`} onClick={() => handleClick("3")} type="button">
          Doświadczenie
        </button>
      );

    return (
      <section id="about">
        <div className="content-wrapper container">
          <aside>
            <h2 className="title">O mnie</h2>
          </aside>
          <div className="content">
            <div className="text-block">
              <p>
                Nazywam się Filip Krawczyk,
                jestem programistą front-end.
                Już&nbsp;od&nbsp;dzieciństwa interesowałem&nbsp;się programowaniem
                i&nbsp;wszystkim co związane&nbsp;z&nbsp;komputerami.
                Aktualnie&nbsp;najwyższą uwagę przywiązuje&nbsp;do
                aplikacji <b>PWA</b>, ze względu na ich możliwości oraz przyszłościowe rozwiązania.
              </p>
            </div>
          </div>
        </div>
        <div className="content-wrapper container">
          <aside className="about-projects">
            <ButtonCapability />
            <ButtonTechnologies />
            <ButtonExperience />
          </aside>
          <div className="content content-static">
            <Section />
          </div>
        </div>
      </section>
    );
}

export default About
